import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {Store} from "@ngrx/store";
import {ActivatedRoute, Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import * as processResultActions from "./process-result.actions"
import {
  bulkStatusTaskResult,
  dispatchBulkActionButton,
  loadSelectedProcessResultSuccess,
  setLoadingActionButton,
  setLoadingBookmarked,
  setLoadingBulkActionButton,
  setloadingBulkRemoveProcessResult,
  setLoadingBulkStatusProcessResult,
  setLoadingBulkStatusTaskResult,
  setLoadingCreateResult,
  setLoadingDetailProcessResult,
  setLoadingProcessResultGridData,
  setLoadingProcessResultPermissions,
  setLoadingResult,
  setLoadingResultTaskAction,
  updateBulkProcessResult
} from "./process-result.actions"
import {catchError, concatMap, map, mergeMap, switchMap, takeUntil, tap, throwError} from "rxjs";
import {ProcessResultService} from "../../services/process-result.service";
import {
  GridTaskResponseI,
  MapResultResponseI,
  ProcessResultI,
  ProcessResultResponseI
} from "../../interfaces/process-result.interface";
import {TaskI, TaskStatus, TaskType} from "../../interfaces/task.interface";
import {loadSelectedTaskSuccess} from "../task/task.actions";
import {TranslateService} from "@mangosoft/mango-layout";

@Injectable()
export class ProcessResultEffects {

  loadProcessResultList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.loadProcessResultList),
      switchMap((action) => {
        return this.processResultService.getProcessResultList(
          action.processId,
          action.page,
          action.limit,
          action.bookmarked,
          action.process_status,
          action.tasks,
          action.filter,
          action.globalSearch
        ).pipe(
          map((response: ProcessResultResponseI) => {
            this.store.dispatch(setLoadingResult({status: false}));
            return processResultActions.loadProcessResultListSuccess({ response: response });
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    )
  );

  loadProcessResults$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.loadProcessResults),
      switchMap((action) => {
        return this.processResultService.getProcessResults(
          action.processId
        ).pipe(
          map((response: ProcessResultResponseI) => {
            this.store.dispatch(setLoadingResult({status: false}));
            return processResultActions.loadProcessResultsSuccess({ response: response });
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    )
  );

  loadProcessResultKanban$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.loadProcessResultKanban),
      concatMap((action) => {
        return this.processResultService.getProcessResultKanban(
          action.processId,
          action.page,
          action.limit,
          action.process_status
        ).pipe(
          map((response: ProcessResultResponseI) => {
            return processResultActions.loadProcessResultKanbanSuccess({
              page: +action.page,
              limit: +action.limit,
              status: action.process_status as string,
              reset: action.reset,
              response: response
            });
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    )
  );

  loadProcessResultMap$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.loadProcessResultMap),
      concatMap((action) => {
        return this.processResultService.getProcessResultMap(
          action.processId,
          action.page,
          action.limit,
          action.bookmarked,
          action.process_status,
          action.tasks,
          action.filter,
          action.globalSearch
        ).pipe(
          map((response: MapResultResponseI) => {
            return processResultActions.loadProcessResultMapSuccess({
              response: response
            });
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    )
  );

  loadProcessResultGridData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.loadProcessResultGridData),
      concatMap((action) => {
        return this.processResultService.getProcessResultGridData({
          processId: action.processId,
      }).pipe(
          map((response: GridTaskResponseI) => {
            this.store.dispatch(setLoadingProcessResultGridData({status: false}));
            return processResultActions.loadProcessResultGridDataSuccess({
              response: response
            });
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    )
  );

  loadProcessResul$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.loadSelectedProcessResult),
      switchMap((action) => {
        return this.processResultService.getProcessResult(
          {processId: action.processId, resultId: action.resultId}
        ).pipe(
          map((response: ProcessResultI) => {
            return processResultActions.loadSelectedProcessResultSuccess({ result: response });
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    )
  );


  loadSocketProcessResul$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.loadSocketProcessResult),
      mergeMap((action) => {
        return this.processResultService.getProcessResult(
          {processId: action.processId, resultId: action.resultId}
        ).pipe(
          map((response: ProcessResultI) => {
            return processResultActions.loadSocketProcessResultSuccess({ result: response });
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            return throwError(error);
          })
        );
      })
    )
  );


  loadDetailProcessResul$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.loadDetailProcessResult),
      switchMap((action) => {
        return this.processResultService.getProcessResult(
          {processId: action.processId, resultId: action.resultId}
        ).pipe(
          map((response: ProcessResultI) => {
            this.store.dispatch(setLoadingDetailProcessResult({status: false}));
            return processResultActions.setDetailProcessResult({ result: response });
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    )
  );

  createProcessResult$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.createProcessResult),
      switchMap((action) => {
        return this.processResultService.createProcessResult(action.processId).pipe(
          tap((response: ProcessResultI) => {
            // turn loading off
            this.store.dispatch(setLoadingCreateResult({status: false}));

            // Filter task to get first draft task
            const first_task = response.tasks.filter((task) => {
              return task.type !== TaskType.GROUP
            })


            //Generate notification
            this.notification.success(
              this.language?.processCreated || "Process created successfully",
              this.language?.success || 'Success'
            );

            if (first_task.length > 0){
              //Redirect to process result view
              this.store.dispatch(loadSelectedTaskSuccess({
                task: first_task[0]
              }));
              this.store.dispatch(loadSelectedProcessResultSuccess({result: response}));
              this.router.navigate([`/process/${action.processId}/process-results/${response.id}/${first_task[0].id}`]);
            }


          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    ), {dispatch: false}
  );

  changeStatusProcessResult$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.changeStatusProcessResult),
      concatMap((action) => {
        return this.processResultService.updateProcessResult({
          processId: action.processId,
          resultId: action.resultId,
          data: action.data
        }).pipe(
          map((response: ProcessResultI) => {
            console.log("Response => ", response);
            // return processResultActions.changeStatusProcessResultSuccess({
            //   previousStatus: action.previousStatus,
            //   index: null,
            //   result: response
            // });
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    ),
    {dispatch: false}
  );

  bookmarkProcessResult$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.bookmarkProcessResult),
      switchMap((action) => {
        return this.processResultService.updateProcessResult({
          processId: action.processId,
          resultId: action.resultId,
          data: action.data
        }).pipe(
          map((response: ProcessResultI) => {
            // turn loading off
            this.store.dispatch(setLoadingBookmarked({status: false}));
            console.log("Bookmarked =>", action.data.bookmarked)
            //Generate notification
            this.notification.success(
              action.data.bookmarked === 'active' ?
                this.language?.processBookmarked || "Process set as bookmarked successfully"
                :
                this.language?.processNotBookmarked || "Process set as not bookmarked successfully" ,
              this.language?.success || 'Success'
            );

            return processResultActions.bookmarkProcessResultSuccess({ result: response });
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            // turn loading off
            this.store.dispatch(setLoadingBookmarked({status: false}));

            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    )
  );

  deleteProcessResult$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.deleteProcessResult),
      switchMap((action) => {
        return this.processResultService.removeProcessResult({
          processId: action.processId,
          resultId: action.resultId
        }).pipe(
          map((response: ProcessResultResponseI) => {
            // turn loading off
            this.store.dispatch(setLoadingResult({status: false}));

            //Generate notification
            this.notification.success(
              this.language?.processRemoved || "Process removed successfully",
              this.language?.success || "Success"
            );

            return processResultActions.loadProcessResultListSuccess({ response: response});
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    )
  );

  executeResultTaskAction$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.executeResultTaskAction),
      switchMap((action) => {
        return this.processResultService.executeProcessResultAction({
          processId: action.processId,
          resultId: action.resultId,
          taskId: action.taskId,
          status: action.status
        }).pipe(
          map((result: ProcessResultI) => {
            // turn loading off
            this.store.dispatch(setLoadingResultTaskAction({status: false}));

            //Generate notification
            this.notification.success(
              this.language?.taskSuccess || "Task action executed successfully",
              this.language?.success || 'Success'
            );

            return processResultActions.executeResultTaskActionSuccess({ result: result});
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    )
  );

  patchResultTask$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.patchResultTask),
      switchMap((action) => {
        return this.processResultService.patchProcessResultTask({
          processId: action.processId,
          resultId: action.resultId,
          taskId: action.task.id,
          activityId: action.activity.id,
          body: action.data
        }).pipe(
          map((result: ProcessResultI) => {
            if (action.nextStatus) {
              return processResultActions.executeResultTaskAction({
                processId: action.processId,
                resultId: action.resultId,
                taskId: action.task.id,
                status: action.nextStatus
              })
            }

            return processResultActions.patchResultTaskSuccess({ result: result});
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    )
  );


  updateProcessResultPermissions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.updateProcessResultPermissions),
      concatMap((action) => {
        return this.processResultService.updateProcessResultPermissions({
          resultId: action.resultId,
          processId: action.processId,
          body: action.data
        }).pipe(
          map((task: TaskI) => {
            return processResultActions.setLoadingProcessResultPermissions({status: false});
            // return taskActions.updateTaskPermissionsSuccess({ task: task });
          }),
          catchError((error) => {
            this.store.dispatch(setLoadingProcessResultPermissions({status: false}));
            console.log(new Date(), "ERROR:", error);
            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    )
  );

  removeProcessResultPermissions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.removeProcessResultPermissions),
      concatMap((action) => {
        return this.processResultService.removeProcessPermissions({
          resultId: action.resultId,
          processId: action.processId,
          body: action.data
        }).pipe(
          map((task: TaskI) => {
            return processResultActions.setLoadingProcessResultPermissions({status: false});
            // return taskActions.updateTaskPermissionsSuccess({ task: task });
          }),
          catchError((error) => {
            this.store.dispatch(setLoadingProcessResultPermissions({status: false}));
            console.log(new Date(), "ERROR:", error);
            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    )
  );

  dispatchActionButton$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.dispatchActionButton),
      switchMap((action) => {
        return this.processResultService.dispatchActionButton({
          processId: action.processId,
          resultId: action.processResultId,
          buttonId: action.buttonId
        }).pipe(
          map((response: any) => {
            // turn loading off
            this.store.dispatch(setLoadingActionButton({
              button: '',
              status: false
            }));

            this.notification.success(this.language?.taskSuccess,  `${this.language?.success || "Success"}!!`)

            return processResultActions.dispatchActionButtonSuccess({
              processId: action.processId,
              processResultId: action.processResultId,
              buttonId: action.buttonId
            });
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            this.store.dispatch(setLoadingActionButton({
              button: '',
              status: false
            }));

            switch (error.status){
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(error.error?.error || this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    )
  );

  bulkRemoveProcessResult$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.bulkRemoveProcessResult),
      switchMap((action) => {
        return this.processResultService.bulkRemoveProcessResult({
          processId: action.processId,
          objectIds: action.values
        }).pipe(
          map((response: { job_id: string }) => {
            // turn loading off
            this.store.dispatch(setloadingBulkRemoveProcessResult({status: false}));

            return processResultActions.setBulkRemoveJobId({
              jobId: response.job_id,
            });
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            this.store.dispatch(setloadingBulkRemoveProcessResult({
              status: false
            }));

            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    )
  );

  bulkStatusProcessResult$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.bulkStatusProcessResult),
      switchMap((action) => {
        return this.processResultService.bulkStatusProcessResult({
          processId: action.processId,
          objectIds: action.objectIds,
          status: action.status
        }).pipe(
          map((response: { job_id: string }) => {
            // turn loading off
            this.store.dispatch(setLoadingBulkStatusProcessResult({status: false}));

            return processResultActions.setBulkStatusJobId({
              jobId: response.job_id,
            });
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            this.store.dispatch(setLoadingBulkStatusProcessResult({
              status: false
            }));

            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    )
  );


  bulkStatusTaskResult$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.bulkStatusTaskResult),
      switchMap((action) => {
        return this.processResultService.bulkStatusTaskResult({
          processId: action.processId,
          taskId: action.taskId,
          objectIds: action.objectIds,
          status: action.status
        }).pipe(
          map((response: { job_id: string }) => {
            // turn loading off
            this.store.dispatch(setLoadingBulkStatusTaskResult({status: ''}));

            return processResultActions.setBulkTaskStatusJobId({
              jobId: response.job_id,
            });
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            this.store.dispatch(setLoadingBulkStatusTaskResult({
              status: ''
            }));

            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    )
  );

  updateBulkProcessResult$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.updateBulkProcessResult),
      switchMap((action) => {
        return this.processResultService.getBulkProcessResults({
          processId: action.processId,
          objectIds: action.objectIds
        }).pipe(
          map((response) => {
            this.store.dispatch(setLoadingResult({status: false}));
            return processResultActions.updateBulkProcessResultSuccess({
              processResultList: response.results,
            });
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            this.store.dispatch(setLoadingResult({status: false}));
            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      })
    )
  );

  dispatchBulkActionButton$ = createEffect(() =>
    this.actions$.pipe(
      ofType(processResultActions.dispatchBulkActionButton),
      switchMap((action) => {
        return this.processResultService.executeBulkActionButton({
          processId: action.processId,
          resultIds: action.processResultIds,
          buttonId: action.buttonId,
          all: action.all
        }).pipe(
          map((response) => {
            this.store.dispatch(setLoadingBulkActionButton({button: ''}));
            this.notification.success(this.language?.taskSuccess,  `${this.language?.success || "Success"}!!`)
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            this.store.dispatch(setLoadingBulkActionButton({button: ''}));
            switch (error.status){
              case 404:
                this.notification.error(error.error, this.language?.processNotFound || "Process not Found")
                break;
              case 403:
                this.router.navigate(["/login"])
                break;
              default:
                this.notification.error(this.language?.errorHappened, "Error !!")
                break
            }
            return throwError(error);
          })
        );
      }),
    ),
    {dispatch: false}
  );

  language: any

	constructor(
		private actions$: Actions,
		private store: Store,
    private router: Router,
    private route: ActivatedRoute,
    private notification: ToastrService,
    private processResultService: ProcessResultService,
    private translateService: TranslateService
	) {
    this.translateService
      .init("process-manager")
      .subscribe((data) => {
        this.language = data
      });
  }
}
